// shopping types
export default {
  GET_SECTIONS: 'GET_SECTIONS',
};
